import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

import * as apiUrl from "../../apiUrl";

function OurteamBanner() {

  const [OurTeamBanner, setOurTeamBanner] = useState({});

  useEffect(() => {
    const fetchOurTeamBanner = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/our-team/banner-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setOurTeamBanner(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchOurTeamBanner();
  }, []);

  return (

    <div className='common-banner-sec our-team-banner'
      style={{
        backgroundImage: `url(${apiUrl.apiUrl + `/` + OurTeamBanner.banner_image
          })`,
      }}
    >
      <Container fluid>
        <Row className='banner-text-center'>
          <Col md={4}>
           <div className="banner-text-topspace">
              <h1 className="common-head whiteColor">
     Leadership
              </h1>
            </div>
          </Col>
        </Row>
      </Container>
    </div>


  );
}

export default OurteamBanner;